/**
 * @fileoverview Type-aware file preview dialog for mail attachments
 * (MOR-783).
 *
 * Used for attachments that are NOT job documents (those open the full
 * document detail sheet instead). Renders through the same type-aware
 * renderer as the document detail's Original tab — PDF/image natively,
 * Word via mammoth, Excel via SheetJS, CSV/text inline — instead of a raw
 * iframe, which made browsers download Office files rather than preview
 * them.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/ui/composed/overlays/dialog";
import { OriginalFilePreview } from "@/components/jobs/phases/gather/documents/DocumentDetail";

export interface FilePreview {
  filename: string;
  contentType: string;
  url: string | null;
}

export function FilePreviewDialog({
  preview,
  onClose,
}: {
  preview: FilePreview | null;
  onClose: () => void;
}) {
  return (
    <Dialog open={preview !== null} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex max-h-[90vh] max-w-4xl flex-col gap-0 p-0">
        <DialogHeader className="border-b px-5 py-3">
          <DialogTitle className="truncate pr-8 text-base">
            {preview?.filename}
          </DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto p-5">
          {preview && (
            <OriginalFilePreview
              url={preview.url}
              fileType={preview.contentType}
              fileName={preview.filename}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
